<template>
    <IconSvg viewBox="0 0 24 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.90803 13.1613L7.02935 11.04L19.2928 23.3034C19.6833 23.694 19.6833 24.3271 19.2928 24.7177L7.02935 36.9811L4.90803 34.8598L15.7573 24.0105L4.90803 13.1613Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
